import React, { useEffect, useState } from "react";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import Container from "react-bootstrap/Container";
import { useToaster } from "../../context/toaster";
import { reportProblemFetcher } from "../../api/requests";
import LoadingIndicator from "../Atomics/Loading/Loading";
import Cookies from "js-cookie";

const ReportProblem = () => {
  const [problems, setProblems] = useState([]);
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const { addMessage } = useToaster();
  const [loading, setLoading] = useState({
    send: false,
    receive: false,
  });
  const [userId, setUserId] = useState();

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  // Handle problem submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!description) {
      showToast("error", "لطفا توضیحات مشکل خود را وارد کنید.");
      return;
    }

    // Create a new problem object
    const formData = new FormData();
    formData.append("problem", description);
    if (image) {
      formData.append("image", image);
    }

    try {
      setLoading({ ...loading, send: true });
      const res = await reportProblemFetcher.post(formData);

      if (res) {
        showToast("success", "پیام شما با موفقیت ثبت شد.");
      }
    } catch (err) {
      console.error(err);
      showToast(
        "error",
        err.response.data[0] ?? "خطایی رخ داده است، دوباره تلاش کنید."
      );
    } finally {
      setLoading({ ...loading, send: false });
    }

    // Clear input fields
    setDescription("");
    setImage(null);
  };

  const getProblems = async () => {
    try {
      setLoading({ ...loading, receive: true });
      setProblems(await reportProblemFetcher.get(300, userId));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading({ ...loading, receive: false });
    }
  };

  useEffect(() => {
    const user = Cookies.get("vaghfnamaUser");
    if (user) {
      const parsedUser = JSON.parse(user);
      setUserId(parsedUser.user_id);
    }
  }, []);

  useEffect(() => {
    if (userId) {
      getProblems();
    }
  }, [userId]);

  return (
    <ContentWrapper>
      <Container fluid style={{ minHeight: "calc(100vh - 81px)" }}>
        <div style={{ margin: "0 auto", padding: "20px", textAlign: "right", width:"100%" }}>
          <h2 style={{ fontSize: "20px" }}>گزارش مشکلات</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "10px", marginTop: "20px" }}>
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                style={{
                  width: "100%",
                  height: "80px",
                  padding: "7px",
                  border: "0px",
                  outline: "none",
                }}
                placeholder="مشکل خود را بنویسید..."
                required
              />
            </div>

            <div
              style={{
                marginBottom: "10px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <label htmlFor="image">
                در صورت لزوم تصویر مرتبط با مشکل را آپلود کنید.
              </label>
              <input
                type="file"
                id="image"
                accept="image/*"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>

            <button
              type="submit"
              style={{
                backgroundColor: "#0fb2aa",
                color: "white",
                border: "none",
                padding: "5px 15px",
                cursor: "pointer",
                borderRadius: "5px",
                marginTop: "12px",
                outline: "none",
              }}
            >
              {loading.send ? "لطفا منتظر بمانید..." : "ارسال"}
            </button>
          </form>

          <h3 style={{ marginTop: "30px", fontSize: "20px" }}>پیام ها</h3>
          {loading.receive ? (
            <LoadingIndicator />
          ) : problems.count === 0 ? (
            <p>پیامی موجود نیست.</p>
          ) : (
            problems.results?.map((problem, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #ddd",
                  padding: "15px",
                  borderRadius: "5px",
                  marginBottom: "15px",
                }}
              >
                <p>
                  <strong>متن پیام</strong> {problem.problem}
                </p>
                {problem.image_of_problem && (
                  <img
                    src={problem.image_of_problem}
                    alt="Problem"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "200px",
                    }}
                  />
                )}
                <p style={{ marginTop: "10px" }}>
                  <strong>وضعیت: </strong>
                  <span
                    style={{
                      color:
                        problem.status ===
                        "fix the problem by the technical team"
                          ? "green"
                          : "orange",
                    }}
                  >
                    {problem.status === "problem design" && "پیام ارسال شد"}
                    {problem.status === "investigating the problem" &&
                      "در حال بررسی"}
                    {problem.status ===
                      "fix the problem by the technical team" && "پاسخ داده شد"}
                  </span>
                </p>
                {problem.status === "Resolved" && (
                  <p>
                    <strong>Reply:</strong> {problem.problem_feedback}
                  </p>
                )}
              </div>
            ))
          )}
        </div>
      </Container>
    </ContentWrapper>
  );
};

export default ReportProblem;
